export const AND = 'AND';
export const OR = 'OR';
export const ASSOCIATION = 'ASSOCIATION';